import { MigrationDefinition } from './migration.types';

/**
 * Migration: V1 → V2
 *
 * Upgrade:
 * - type String-Format ändern (z.B. "Bohrpunkt" → "6_Bohrpunkt")
 *
 * Downgrade:
 * - type String-Format zurück (z.B. "6_Bohrpunkt" → "Bohrpunkt")
 */
export const migrationV1ToV2: MigrationDefinition = {
  fromVersion: 1,
  toVersion: 2,

  upgrade(doc: any): any {
    const typeMapping: Record<string, string> = {
      'Weisergrube': '1_Weisergrube_ohne_Bodenanalyse',
      'Bodengrube': '3_Bodengrube_ohne_Bodenanalyse',
      'Humusprobe': '5_Humusprobe',
      'Bohrpunkt': '6_Bohrpunkt',
      'Moorpunkt': '7_Moorpunkt',
      'Abgrenzbohrung': '9990_Abgrenzbohrung',
      'Halbtiefbohrung': '9998_Halbtiefbohrung',
      'Grenzaufschluss': '9999_Grenzaufschluss'
    };

    if (typeMapping[doc.type]) {
      doc.type = typeMapping[doc.type];
    }

    doc.version = 2;
    return doc;
  },

  downgrade(doc: any): any {
    const reverseMapping: Record<string, string> = {
      '1_Weisergrube_ohne_Bodenanalyse': 'Weisergrube',
      '3_Bodengrube_ohne_Bodenanalyse': 'Bodengrube',
      '5_Humusprobe': 'Humusprobe',
      '6_Bohrpunkt': 'Bohrpunkt',
      '7_Moorpunkt': 'Moorpunkt',
      '9990_Abgrenzbohrung': 'Abgrenzbohrung',
      '9998_Halbtiefbohrung': 'Halbtiefbohrung',
      '9999_Grenzaufschluss': 'Grenzaufschluss'
    };

    if (reverseMapping[doc.type]) {
      doc.type = reverseMapping[doc.type];
    }

    doc.version = 1;
    return doc;
  },

  dataLossWarnings: [
    'Neue Punktarten (z.B. 6_Tiefbohrung) werden zu "Bohrpunkt" konvertiert'
  ]
};
